module.exports = __webpack_public_path__ + "static/img/recharge.b3ee771.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recharge.png
// module id = WPyH
// module chunks = 0